import axios from 'axios'
const defaultSettings = require('../settings')

// create an axios instance
const service = axios.create({
  // baseURL: '/',
  baseURL: defaultSettings.baseUrl,
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 1800000 // request timeout(ms)
})

// request interceptor
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('access_token')
    if (token) {
      // 添加JWT token到请求头
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
// service.interceptors.response.use(
//   response => {
//     const res = response.data
//     if (res.success) {
//       return res
//     } else {
//       main.$message({
//         message: res.msg || '发生异常',
//         type: 'warning',
//         showClose: true,
//         duration: 3000
//       })

//       Promise.reject(new Error(res.msg || '发生异常'))
//       throw res.msg || '发生异常'
//     }
//   },
//   error => {
//     if (error.response.status === 401) {
//       main.$message({
//         message: '会话已失效，请重新登录',
//         type: 'warning',
//         showClose: true,
//         duration: 3000
//       })

//       // 跳转到本地登录页面
//       location.href = '/' + defaultSettings.secondRouter
//       return Promise.reject(error)
//     } else if (error.response.status === 404) {
//       this.$router.push({ path: '/404' })
//     } else {
//       main.$message({
//         message: error.response.data.msg
//           ? error.response.data.msg
//           : error.message,
//         type: 'warning',
//         showClose: true,
//         duration: 3000
//       })

//       Promise.reject(error)
//       throw '发生异常'
//     }
//   }
// )

export default service
